export default "__VITE_ASSET__DZw_ivsX__"